// paystack.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaystackService {
  initiatePayment(pubKey: string, amount: number, email: string): Promise<any> {
    
    return new Promise((resolve, reject) => {
      // Use Paystack Inline to initiate payment
      const handler = (window as any).PaystackPop.setup({
        key: pubKey,
        email,
        amount,
        currency: 'NGN',
        // other configurations...
        callback: (response) => {
          console.log(response);
          // Handle success or failure
          resolve(response); // Resolve the promise with the response
        },
        onClose: () => {
          console.log('Payment closed');
          // Handle payment closure
          reject(new Error('Payment closed')); // Reject the promise on closure
        },
      });

      handler.openIframe();
    });
  }
}
